import { Alert, Box } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import { PowerBIEmbed } from "powerbi-client-react";
import { useEffect, useRef } from "react";

interface SearchParams {
    embedUrl?: string;
    accessToken?: string;
}

export const Route = createFileRoute("/_authenticated/report")({
    component: Component,
    validateSearch: (search: Record<string, unknown>): SearchParams => {
        return {
            embedUrl: search.embedUrl as string | undefined,
            accessToken: search.accessToken as string | undefined,
        };
    },
});

function Component() {
    const { embedUrl, accessToken } = Route.useSearch();

    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        resize();
    }, []);

    const resize = () => {
        const iframe = document.getElementsByTagName("iframe")[0];
        if (iframe == null) {
            return;
        }

        iframe.style.borderStyle = "none";

        if (ref.current == null) {
            return;
        }
        iframe.style.height = ref.current?.parentElement?.clientHeight + "px";
    };

    if (embedUrl == undefined || accessToken == undefined) {
        return <Alert severity={"error"}>Embed Url and/or Access Token missing</Alert>;
    }

    return (
        <Box ref={ref}>
            <PowerBIEmbed
                embedConfig={{
                    type: "report",
                    embedUrl,
                    accessToken,
                    tokenType: 1,
                }}
            />
        </Box>
    );
}
